import { ICategoryType } from '@introspection/index';
import { Form, FormGroup } from '@rxdi/forms';
import { Component, css, html, LitElement, property } from '@rxdi/lit-html';
import { InputStyle } from '@rxdi/ui-kit/styles/form/input';

import { InputErrorTemplate } from './input-error.template';

/**
 * @customElement create-category-forms
 */
@Component({
  selector: 'create-category-forms',
  styles: [
    InputStyle,
    css`
      input {
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 0px;
      }
      .content {
        padding: 10px 30px 10px 30px;
        border-bottom: 1px solid #e5e5e5;
        overflow: auto;
        min-height: 100px;
        max-height: 385px;
      }
      .is-invalid {
        box-shadow: 0 0 1px 1px #c95454;
      }
    `,
  ],
  template(this: CreateCategoryFormComponent) {
    return html`
      <form
        name="create-category-forms"
        novalidate
        @submit=${async () => {
          const validity = await this.form.updateValueAndValidity();

          if (!validity?.length) {
            this.dispatchEvent(
              new CustomEvent<ICategoryType>('submitted', {
                detail: this.form.value,
              })
            );
          }
        }}
      >
        <div class="content">
          <p>Name</p>
          <input
            type="text"
            name="name"
            class="rx-input"
            .disabled=${!!this.model?.name}
            minlength=${3}
            value=${this.model?.name ? this.model?.name : ''}
            required
          />
          ${InputErrorTemplate(this.form.get('name'))}
    

          <p>Description</p>
          <input
            type="text"
            name="description"
            class="rx-input"
            .disabled=${!!this.model?.description}
            minlength=${3}
            value=${this.model?.description ? this.model?.description : ''}
            required
          />
          ${InputErrorTemplate(this.form.get('description'))}
            </div>
        </div>
        <div style="padding: 20px;">
            <sl-button style="width:100%;" type="submit" variant="primary">Create Category</sl-button>
        </div>
      </form>
    `;
  },
})
export class CreateCategoryFormComponent extends LitElement {
  @property({ type: Object })
  model: ICategoryType;

  @property({ type: Array })
  categories: ICategoryType[];

  @Form({
    name: 'create-category-forms',
    strategy: 'change',
    strict: true,
  })
  form = new FormGroup<ICategoryType>({
    name: ['', [this.validateExistingCategories]] as never,
    description: '',
  });

  OnUpdateFirst() {
    const model = this.model || {};
    Object.keys(model).map((key: never) => {
      if (this.form.get(key) && model[key]) {
        this.form.setValue(key, model[key]);
      }
    });
  }

  private validateExistingCategories(element: HTMLInputElement) {
    if (this.categories.find((c) => c.name === element.value)) {
      return {
        key: 'category-present',
        message: 'Category present! Please specify different category',
      };
    }
  }
}
